<template>
  <div class='editPostIndex'>
    <div class='cont'>
      <div v-if="jobInfo">
        <div class="topBox">
          <div class="ipnutBox">
            <div class="title">
              公司
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-select filterable v-model="companyId" placeholder="请选择要发职位的公司">
                  <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                  <div style="font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;" @click="mmm" v-if="comapnyPages > companyPageNumber">加载更多</div>
                </el-select>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              职位名称
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-cascader placeholder='请选择职位类型' :options="jobTypeOptions" :show-all-levels="false"
                  @change="changejobType"></el-cascader>
                <span>职位名称：</span>
                <el-input width='300' v-model="jobInfo.positionName" placeholder="请输入职位名称"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              职位标签
            </div>
            <div class="inputCont">
              <el-checkbox-group v-model="jobInfo.jobTags" size="mini">
                <el-checkbox label="预" border>是否预付</el-checkbox>
                <el-checkbox label="独" border>是否独家</el-checkbox>
                <el-checkbox label="急" border>是否加急</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              工作地址
            </div>
            <div class="inputCont">
              <el-select style="width: 400px" v-model="searchaddres" clearable filterable remote reserve-keyword
                placeholder="请输入地点进行搜索" :remote-method="getSearchSuggestion" :loading="searchloading"
                @clear="searchClear" @change="searchChange">
                <el-option v-for="item in searchSuggestion" :key="item.id"
                  :label="item.address + '(' + item.title + ')'" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              所属部门
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.branch" placeholder="请输入职位所属部门"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              月薪范围
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.salaryMin" @change="goeditsalaryMin"
                :min="1"></el-input-number><span> k~ </span>
              <el-input-number size="small" v-model="jobInfo.salaryMax" @change="goeditsalaryMax"
                :min="1"></el-input-number><span> k</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              薪资月份
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.numberSalary" :min="12"
                @change="goeditnumberSalary"></el-input-number><span> 薪</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              年度奖金
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.bonus" :min="0" @change="goeditbonus"
                :step="0.01"></el-input-number><span> w</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              工作年限
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.workingLifeMin" @change="goeditworkingLifeMin" :min="0"
                :max="11"></el-input-number><span> 年~ </span>
              <el-input-number size="small" v-model="jobInfo.workingLifeMax" @change="goeditworkingLifeMax" :min="0"
                :max="11"></el-input-number><span> 年</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              最低学历
            </div>
            <div class="inputCont">

              <el-radio-group v-model="jobInfo.minEducation" size="mini">
                <el-radio label="博士" border>博士</el-radio>
                <el-radio label="硕士" border>硕士</el-radio>
                <el-radio label="本科" border>本科</el-radio>
                <el-radio label="大专" border>大专</el-radio>
                <el-radio label="高中" border>高中</el-radio>
                <el-radio label="中专/中技" border>中专/中技</el-radio>
                <el-radio label="初中及以下" border>初中及以下</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              面试轮次
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.interviewNumber" :min="0"></el-input-number><span> 轮</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              招聘人数
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.recruitsNumber" :min="0"></el-input-number><span> 人</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              职位有效期
            </div>
            <div class="inputCont">
              <el-date-picker v-model="jobInfo.expirationDate" type="date" :picker-options="pickerOptions"
                placeholder="选择职位有效期">
              </el-date-picker>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              岗位职责
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.postDuties">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              岗位要求
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.postReQuirements">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              特殊说明（非必填）
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.des">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              佣金比例
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.commissionRate" :min="10"
                :max="30"></el-input-number><span> %</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              保证期
            </div>
            <div class="inputCont">

              <el-radio-group v-model="jobInfo.warranty" size="mini">
                <el-radio label="一个月" border>一个月</el-radio>
                <el-radio label="两个月" border>两个月</el-radio>
                <el-radio label="三个月" border>三个月</el-radio>
                <el-radio label="四个月" border>四个月</el-radio>
                <el-radio label="五个月" border>五个月</el-radio>
                <el-radio label="六个月" border>六个月</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              分成比例
            </div>
            <div class="inputCont">
              <el-radio-group v-model="jobInfo.payRules" size="mini">
                <el-radio label="1:9" border>1:9</el-radio>
                <el-radio label="2:8" border>2:8</el-radio>
                <el-radio label="3:7" border>3:7</el-radio>
                <el-radio label="4:6" border>4:6</el-radio>
                <el-radio label="5:5" border>5:5</el-radio>
              </el-radio-group>

              <span style="margin-left: 16px">（分成描述：{{ getPayRuleDesc(jobInfo.payRules) }}）</span>
            </div>
          </div>

          <div class="ipnutBox">
            <div class="title">
              职位情况
            </div>
            <div class="inputCont">
              <el-radio-group v-model="jobInfo.jobPosition" size="mini">
                <el-radio label="新增职位" border>新增职位</el-radio>
                <el-radio label="替补职位" border>替补职位</el-radio>
                <el-radio label="空缺职位" border>空缺职位</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              汇报对象
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.reportObject" placeholder="请输入该职位的汇报对象"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              下属人数
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' type="number" v-model="jobInfo.subordinates" placeholder="请输入该职位的下属人数"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              是否隐藏公司名称
              <el-switch v-model="isCompany" active-text="隐藏" inactive-text="不隐藏" @change="changeisCompany">
              </el-switch>
            </div>
            <div class="inputCont">

              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.companyNameCustom" placeholder="请输入匿名之后显示的公司代称"></el-input>
              </div>
            </div>
          </div>
          <div class="btnBox">
            <el-button round @click="postStart">发布职位</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'
export default {
  name: 'newPostGM',
  props: {},
  data() {
    return {
      jobTypeOptions: [],
      seacherregion: '',
      searchaddres: '',
      searchloading: false,
      searchSuggestion: [],
      pickerOptions: {
        disabledDate(time) {
          let str = moment(time).format('YYYY-MM-DD')
          let star = moment().unix() * 1000;
          let last = moment().add(6, 'M').unix() * 1000;
          return time.getTime() < star || time.getTime() > last;
        }
      },
      jobInfo: {
        positionName: '',
        salaryMax: '',
        salaryMin: '',
        workingLifeMin: '',
        workingLifeMax: '',
        workingAddress: '',
        postDuties: '',
        postReQuirements: '',
        minEducation: '',
        interviewNumber: '',
        recruitsNumber: '',
        commissionRate: '',
        warranty: '',
        payRules: '5:5',
        bonus: '',
        numberSalary: '',
        minYearSalary: '',
        maxYearSalary: '',
        des: '',
        branch: '',
        jobPosition: '',
        reportObject: '',
        subordinates: '',
        isCompany: '0',
        label: '',
        jobTags: [],
        expirationDate: moment().add(1, 'M').format('YYYY-MM-DD')
      },
      isCompany: false,
      companyPageNumber: 1,
      companyPageSize: 100,
      companyList: [],
      companyId: '',
      comapnyPages: 1
    }
  },
  watch: {},
  created: function () {
    this.getIp()
    this.getJobTypeArray()
    this.getCompanyList()
  },
  methods: {
    getJobTypeArray: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/treedata/gettreeData',
      }).then((res) => {
        if (res.data.success === '1') {
          that.gsArray(res.data.content)
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    gsArray: function (list) {
      for (let i in list) {
        let item = list[i]
        item.label = item.name
        item.value = item.name + ',' + item.code
        if (item.childrenlist) {
          item.children = item.childrenlist
          for (let j in item.children) {
            let item2 = item.children[j]
            item2.label = item2.name
            item2.value = item2.name + ',' + item2.code
            if (item2.childrenlist) {
              item2.children = item2.childrenlist
              for (let k in item2.children) {
                let item3 = item2.children[k]
                item3.label = item3.name
                item3.value = item3.name + ',' + item3.code
              }
            }
          }
        }
      }
      this.jobTypeOptions = list
    },
    changejobType: function (e) {
      this.jobInfo.jobTypeCode = e[e.length - 1].split(',')[1]
      this.jobInfo.jobType = e[e.length - 1].split(',')[0]
    },
    goeditsalaryMin: function (e) {
      if (e <= this.jobInfo.salaryMax) {
        this.jobInfo.salaryMin = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditsalaryMax: function (e) {
      if (e >= this.jobInfo.salaryMin) {
        this.jobInfo.salaryMax = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditnumberSalary: function (e) {
      this.jobInfo.numberSalary = e
      this.sumYearSalary()
    },
    goeditbonus: function (e) {
      this.jobInfo.bonus = e
      this.sumYearSalary()
    },
    sumYearSalary: function () {
      this.jobInfo.minYearSalary = Number(this.jobInfo.salaryMin * this.jobInfo.numberSalary) * 10 / 100,
        this.jobInfo.maxYearSalary = Number(Number(this.jobInfo.salaryMax * this.jobInfo.numberSalary) * 10 / 100) + Number(this.jobInfo.bonus)
    },
    goeditworkingLifeMin: function (e) {
      if (e <= this.jobInfo.workingLifeMax) {
        this.jobInfo.workingLifeMin = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    goeditworkingLifeMax: function (e) {
      if (e >= this.jobInfo.workingLifeMin) {
        this.jobInfo.workingLifeMax = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    getIp: function () {
      let that = this
      this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip', {
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        ip: '220.249.55.194',
        output: 'jsonp'
      })
        .then(res => {
          if (res.status === 0) {
            this.seacherregion = res.result.ad_info.city
          } else {
            this.seacherregion = '北京市'
          }
        })
        .catch(err => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
        })
    },

    getSearchSuggestion: function (e) {
      let that = this
      that.searchloading = true


      this.$jsonp('https://apis.map.qq.com/ws/place/v1/suggestion', {
        keyword: e,
        region: this.seacherregion,
        region_fix: 0,
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        output: 'jsonp'
      })
        .then(res => {
          that.searchloading = false
          if (res.status === 0) {
            for (let i in res.data) {
              res.data[i].value = res.data[i].address + '(' + res.data[i].title + ')'
              res.data[i].label = res.data[i].address + '(' + res.data[i].title + ')'
            }
            that.searchSuggestion = res.data
          }
        })
        .catch(err => {
          that.searchloading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
        })
    },

    searchClear: function () {
      this.searchaddres = ''
      this.searchloading = false
      this.searchSuggestion = []
    },

    searchChange: function (e) {
      this.jobInfo.cityCode = e.adcode
      this.jobInfo.provinceName = e.province
      this.jobInfo.cityName = e.city
      this.jobInfo.areaName = e.district
      this.jobInfo.workingAddress = e.address
      this.jobInfo.location = e.location.lat + ',' + e.location.lng
    },
    changeisCompany: function (e) {
      if (e) {
        this.jobInfo.isCompany = '1'
      } else {
        this.jobInfo.isCompany = '0'
      }
    },
    postStart: function () {
      let that = this

      if (that.companyId === '' || that.companyId === undefined) {
        that.$message.warning('请选择公司')
        return false
      }
      if (that.jobInfo.positionName === '' || that.jobInfo.positionName === undefined) {
        that.$message.warning('请输入职位名称')
        return false
      }
      if (that.jobInfo.workingAddress === '' || that.jobInfo.workingAddress === undefined) {
        that.$message.warning('请输入工作地点具体位置')
        return false
      }
      if (that.jobInfo.postDuties === '' || that.jobInfo.postDuties === undefined) {
        that.$message.warning('请输入岗位职责')
        return false
      }
      if (that.jobInfo.postReQuirements === '' || that.jobInfo.postReQuirements === undefined) {
        that.$message.warning('请输入岗位要求')
        return false
      }
      if (that.jobInfo.minEducation === '' || that.jobInfo.minEducation === undefined || that.jobInfo.minEducation === '选择学历') {
        that.$message.warning('请输入该职位的最低学历要求')
        return false
      }
      if (that.jobInfo.warranty === '' || that.jobInfo.warranty === undefined || that.jobInfo.warranty === '请选择职位保证期') {
        that.$message.warning('请选择该职位的保证期')
        return false
      }
      if (that.jobInfo.payRules === '' || that.jobInfo.payRules === undefined || that.jobInfo.payRules === '请选择分成比例') {
        that.$message.warning('请选择该职位的分成比例')
        return false
      }
      if (that.jobInfo.jobTypeCode === '' || !that.jobInfo.jobTypeCode) {
        that.$message.warning('请选择该职位类型')
        return false
      }
      let data = that.jobInfo
      data.companyId = that.companyId
      data.label = data.jobTags.join(':')
      delete data.jobTags

      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/replease',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        },
        data,
      }).then((res) => {
        if (res.data.success === '1') {
          that.$notify({
            title: '提示',
            message: '职位发布成功',
            type: 'success',
            duration: 1000
          });
          that.$router.push({
            path: '/myReceiveResume',
          })
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getCompanyList: function () {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise//company/getCompanyList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json'
        },
        data: {
          pageNum: that.companyPageNumber,
          pageSize: that.companyPageSize
        },
      }).then((res) => {
        if (res.data.success === '1') {
          for (let i in res.data.content.list) {
            res.data.content.list[i].value = res.data.content.list[i].id
            res.data.content.list[i].label = res.data.content.list[i].company
          }
          that.companyList = that.companyList.concat(res.data.content.list)
          that.comapnyPages = res.data.content.pages
        } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })

    },
    mmm: function () {
      this.companyPageNumber = this.companyPageNumber + 1
      this.getCompanyList()
    },
    getPayRuleDesc: function (payRules) {
      const parts = payRules.split(':')
      const p = 1
      const a = (+parts[0] - p) * 10 + '%'
      const b = +parts[1] * 10 + '%'
      return `平台${p * 10}% 发单${a} 做单${b}`
    }
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.editPostIndex {
  width: 100%;
  height: 100%;
  padding-top: 1px;
  position: relative;

  .cont {
    width: 100vw;
    overflow-x: scroll;
    height: calc(100% - 80px);
    background-color: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    // overflow: hidden;
    overflow-y: scroll;

    .topBox {
      .name {
        color: #5DC2D0;
        font-size: 32px;
        font-weight: bold;
        padding-bottom: 10px;
        border-bottom: 2px solid #5DC2D0;

        span {
          font-size: 12px;
        }
      }

      .info {
        padding-top: 10px;
        font-size: 12px;
        color: #5DC2D0;
        width: max-content;
        border-bottom: 2px solid #5DC2D0;
        padding-bottom: 10px;
      }

      .ipnutBox {
        * {
          background-color: transparent;
          color: #5DC2D0;
          outline: none;
        }

        .title {
          color: #5DC2D0;
          padding: 20px 0;
        }

        .inputCont {
          .posNameBox {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            span {
              margin: 0 10px 0 20px;
            }

            .el-input {
              width: 300px;
            }
          }
        }
      }

      .btnBox {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        button {
          background-color: transparent;
          color: #5DC2D0;
        }
      }
    }
  }
}
</style>
